import { useEffect, useState } from 'react';

export const useScreenWidth = () => {
  const [width, setWidth] = useState(window.innerWidth);

  const handleWindowSizeChange = () => {
    setWidth(window.innerWidth);
  };

  useEffect(() => {
    window.addEventListener('resize', handleWindowSizeChange);
    return () => {
      window.removeEventListener('resize', handleWindowSizeChange);
    };
  }, []);

  return {
    screenWidth: width,
    isMobile: width < 768,
    isTablet: width >= 768 && width <= 1024,
    isLaptop: width > 1024 && width < 1280,
    isDesktop: width >= 1280,
  };
};
